import { useReactiveVar } from '@apollo/client'
import { isClientSideVar } from 'lib/apollo/reactive-vars'

export const useIsClientSide = (): boolean => useReactiveVar(isClientSideVar)
